import { IMedicalRecord } from '@nkr/models/index';

export interface IDetailData extends IMedicalRecord {
    centerId?: number,
    centerName?: string,
    patientScreenId: number,
    referralStatusId: number,
    stateProvinceValue: string,
    otherCountry: string,
    createRecipient: boolean,
    createMicrosite: boolean,
    approveTransfer?: number
}